import { Audit, AuditType, AuditValue, UserBasic } from '@hefe/models';
import { formatDateTime } from '@hefe/utils';
import { List, Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { BsArrowRightShort } from 'react-icons/bs';
import CustomList from '../../../../core/components/custom-list/custom-list.component';
import UserAvatar from '../../../../core/components/user/user-avatar/user-avatar/user-avatar.component';

interface EventDetailsAuditsComponentProps {
  audits: Audit[];
}

export default function EventDetailsAuditsComponent(
  props: EventDetailsAuditsComponentProps
) {
  const systemUser: UserBasic = {
    id: 0,
    firstname: 'System',
    lastname: '',
    avatar: '',
  };

  const getAttributeKey = (value: string) => {
    let returnValue = value;
    if (value.startsWith('judge_')) {
      returnValue = value.replace('judge_', '');
      returnValue = `judges.${returnValue}`;
    }

    return returnValue.replace('_id', '');
  };

  const renderChange = (value: AuditValue) => {
    return (
      <Space direction="vertical" key={value.attribute}>
        <Typography.Text strong>
          {t(getAttributeKey(value.attribute))}
        </Typography.Text>
        <Space align="start">
          <Typography.Text style={{ textDecoration: 'line-through' }}>
            {value.old_value || t('pending')}
          </Typography.Text>
          <BsArrowRightShort size={24} />
          <Typography.Text>{value.new_value || t('pending')}</Typography.Text>
        </Space>
      </Space>
    );
  };

  const renderItem = (audit: Audit) => {
    const user = audit.user ?? systemUser;

    const username = `${user?.firstname} ${user?.lastname}`;
    let headerText = t('information_texts.user_updated_event', {
      user: username,
    });
    if (audit.event === AuditType.CREATED) {
      headerText = t('information_texts.user_created_event', {
        user: username,
      });
    }

    return (
      <List.Item key={audit.id}>
        <Space direction="vertical">
          <Space align="start" style={{ marginBottom: 10 }}>
            <UserAvatar user={user} size="small" />
            <Space direction="vertical" size={0}>
              <Typography.Text strong>{headerText}</Typography.Text>
              <Typography.Text style={{ fontSize: 12 }}>
                {formatDateTime(audit.date)}
              </Typography.Text>
            </Space>
          </Space>
          {audit.event !== AuditType.CREATED &&
            audit.values.map((value) => renderChange(value))}
        </Space>
      </List.Item>
    );
  };

  return (
    <CustomList
      dataSource={props.audits}
      renderItem={(item) => renderItem(item)}
    />
  );
}
